/* eslint-disable @typescript-eslint/no-empty-function */
import { useEffect, useState } from 'react';
import { Roles } from 'src/constants';
import { getOrgUsers } from 'src/services/apiService';
import { OrgUser } from 'src/types';
import useAuth from './useAuth';

const useOrgSshAdmins = (associateId?: string) => {
  const { user } = useAuth();
  const [admins, setAdmins] = useState<OrgUser[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSshAdmins = async () => {
      try {
        const allUsers = await getOrgUsers(associateId ?? user.organisationId);
        const sshAdmins = allUsers.filter((user) =>
          user.roles.includes(Roles.SCHOOL_SUPPORT_HUB_COORDINATOR)
        );
        setAdmins(sshAdmins);
      } catch (e) {
        setError(e.message);
      }
    };

    if (user?.organisationId) {
      fetchSshAdmins();
    }

    return () => {
      setAdmins([]);
      setError(null);
    };
  }, [user.organisationId]);

  return { admins, error };
};

export default useOrgSshAdmins;
